import * as React from 'react';
import { Button } from 'antd';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from "src/core/Routes";
import { withLocalize, LocalizeContextProps, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import GuideSection from '../../components/public/GuideSection';


interface RouteProps {
    gradeId: number;
    planet: string;
}

interface ParentsPlanetProps extends PageProps<RouteProps>, LocalizeContextProps {
}

class ParentsPlanet extends React.Component<ParentsPlanetProps> {
    constructor(props: ParentsPlanetProps) {
        super(props);
        bindAllOfThis(this, ParentsPlanet.prototype);
    }

    private getListFromJSON(path: string, length: number) {
        let list = [];

        if (!path.endsWith('.')) {
            path += '.';
        }

        let i: number = 1;
        const errorMessage = "No default translation found! Ensure you've added translations for your default langauge.";
        
        while (i <= length) {
           let translationKey = path + i++;
            // Convert to string to ensure we can compare it properly
           let translation = this.props.translate(translationKey).toString();
            
            // Check if translation is missing or is the error message
            if (!translation || translation === "" || translation === errorMessage) {
                break;
            }

            list.push(translationKey);
        }

        return list;
    }

    render() {
        let suggestions = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".suggestion.", 20);
        let books = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".book.", 20);
        return <div className="parents-portal">
            <h2><Translate id="public.parents.pageHeader" /></h2>
            <h3><Translate id={"public.parents.planetLinks." + this.props.match.params.planet} /></h3>
            <GuideSection
                bodyKey={[
                    "public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".body1",
                    "public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".body2",
                    "public.parents.suggestions"
                ]}
                listBodyKeys={suggestions}
                listBodyKeysSecondLevel={books}
                headerKeySecondLevel="public.parents.books"
            />
            <Link to={Routes.getRoute(Routes.PARENTS, this.props.match.params.gradeId)}>
                <Button icon="left"><Translate id="common.back" /></Button>
            </Link>
        </div>;
    }
}

export default withLocalize(ParentsPlanet as any) as any;



// WEBPACK FOOTER //
// ./src/pages/public/ParentsPlanet.tsx